export default class TableFilter {
  static FILTER_TYPE_DATE_RANGE = 'dateRange'
}
